/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2021, Zumper
 */

// sets the quality of the images (`q` param)
export const PIXEL_RATIOS = {
  1: 76,
  1.5: 51,
  2: 39,
  3: 26,
  4: 21,
} as const
